// src/config/apiRoutes.js

import httpService from "../services/httpService";

const API_URL = process.env.REACT_APP_API_URL || 'https://inab.sinoxe.com/api/driver';

export const API_ROUTES = {
    // AUTH
    LOGIN: (user_name, password) => httpService.post(`${API_URL}/auth/login`, { user_name, password }),

    // DELIVERY
    GET_DELIVERIES: (params) => httpService.get(`${API_URL}/delivery/deliveries`, { params }),
    REGISTER_RECEIPT: (formData) => httpService.post(`${API_URL}/delivery/register-receipt`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),


    ACTION: (formData) => httpService.post(`${API_URL}/delivery/action`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    SEARCH: (searchParams) => httpService.get(`${API_URL}/delivery/search`, { params: searchParams }),
    DETAILS: (id) => httpService.get(`${API_URL}/delivery/deliveries/${id}`),
    UPDATE: (id, updateData) => httpService.put(`${API_URL}/delivery/deliveries/${id}`, updateData),
    CANCEL: (id, reason) => httpService.post(`${API_URL}/delivery/deliveries/${id}/cancel`, { reason }),
    REPORT: (filters) => httpService.get(`${API_URL}/delivery/report`, { params: filters }),
    BULK_CONFIRM: (deliveryIds) => httpService.post(`${API_URL}/delivery/bulk-confirm`, { delivery_ids: deliveryIds }),


    // BANKS
    BANKS_ACCOUNT: () => httpService.get(`${API_URL}/bank-accounts`),
};